/**
 * A one-shot flag carried from registration to the verification screen.
 *
 * `sendEmailVerification` runs immediately after the account is created — at
 * which point `onAuthStateChanged` has already fired and the router is
 * unmounting RegisterScreen. Any state it sets is discarded, so a failure to
 * send would leave the contractor watching for an email nobody attempted.
 *
 * sessionStorage rather than a context field because the two screens do not
 * overlap in time: one is being torn down as the other mounts.
 */
export const VERIFICATION_SEND_FAILED = "shoku.contractor.verificationSendFailed";

/** Reads the flag and clears it, so it reports each failure exactly once. */
export function takeVerificationSendFailure(): boolean {
  try {
    const failed = sessionStorage.getItem(VERIFICATION_SEND_FAILED) === "1";
    if (failed) sessionStorage.removeItem(VERIFICATION_SEND_FAILED);
    return failed;
  } catch {
    return false;
  }
}
